import { isEastTerritory } from 'common/utils/checkTerritory';

export const WEST_MOBILITY_NAME = 'E100 Mobility';
export const EAST_MOBILITY_NAME = 'E1 Mobility';

export const MOBILITY_NAME = isEastTerritory ? EAST_MOBILITY_NAME : WEST_MOBILITY_NAME;
